export enum ConversationSourceEnum {
  WIDGET = 'widget',
  API = 'api',
  PREVIEW = 'preview',
  TELEGRAM = 'telegram',
  SLACK = 'slack',
  MESSENGER = 'messenger',
  DISCORD = 'discord',
  INSTAGRAM = 'instagram',
  WHATSAPP = 'whatsapp',
  INTERCOM = 'intercom',
  HUBSPOT = 'hubspot',
  ZENDESK = 'zendesk',
  PUBLIC__LINK = 'public_link',
  EMBED = 'embed',
  MCP = 'mcp',
  MCP__CLAUDE = 'mcp_claude',
  MCP__CURSOR = 'mcp_cursor',
  MCP__CHATGPT = 'mcp_chatgpt',
  MCP__MISTRAL = 'mcp_mistral',
  SIMULATION = 'simulation',
  EMAIL = 'email',
  PUBLIC_QUESTION = 'public_question',
  PUBLIC_QUESTION_CHATGPT = 'public_question_chatgpt',
  PUBLIC_QUESTION_CLAUDE = 'public_question_claude',
  PUBLIC_QUESTION_PERPLEXITY = 'public_question_perplexity',
}
